import { render, staticRenderFns } from "./60489cdc-f137-4e08-ac4f-45a23541fe66.vue?vue&type=template&id=fe3dd9e8&scoped=true"
import script from "./60489cdc-f137-4e08-ac4f-45a23541fe66.vue?vue&type=script&lang=ts"
export * from "./60489cdc-f137-4e08-ac4f-45a23541fe66.vue?vue&type=script&lang=ts"
import style0 from "./60489cdc-f137-4e08-ac4f-45a23541fe66.vue?vue&type=style&index=0&id=fe3dd9e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3dd9e8",
  null
  
)

export default component.exports